import { Component, OnInit, Input } from '@angular/core';

import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { Person } from '../../../../models/person';
import { EmployeeAuditRow } from '../../../../models/employee-audit';
import { Pagination } from '../../../../models/pagination';
import { AuditAction, EmployeeEditRecord } from '../../../../models/audit-action';
import { ActivatedRoute } from '@angular/router';
import { AuditService } from '../../../../services/audit.service';

@Component({
  selector: 'app-audit-log-tab',
  templateUrl: './audit-log-tab.component.html',
  styleUrls: ['./audit-log-tab.component.css'],
  standalone: false
})
export class AuditLogTabComponent implements OnInit {
  @Input() person: Person;
  clientCode: string;
  data: EmployeeEditRecord[];
  pagination: Pagination = new Pagination();
  sortKey: string;
  sortDirection: string;
  filters = {
    activityQuery: '',
    attrNameQuery: '',
    userIdQuery: ''
  };
  searchSubject = new Subject<void>();

  constructor(
    private auditService: AuditService,
    private route: ActivatedRoute
  ) {}

  getEmployeeAuditData() {
    this.auditService
      .getEmployeeAuditData(this.clientCode, {
        personId: this.person.Id.toString(),
        pageNum: this.pagination.Page,
        sortKey: this.sortKey,
        sortDirection: this.sortDirection,
        ...this.filters
      })
      .subscribe(resp => {
        this.data = resp.Items;
        this.pagination = resp.Pagination;
      });
  }

  filterBy(event) {
    this.pagination.Page = 1; // reset pagination after filters change
    this.searchSubject.next();
  }

  loadPage({ Page }: Pagination) {
    this.pagination.Page = Page;
    this.getEmployeeAuditData();
  }

  ngOnInit() {
    this.clientCode = this.route.snapshot.paramMap.get('client_code');
    this.getEmployeeAuditData();

    this.searchSubject.pipe(debounceTime(500)).subscribe(() => this.getEmployeeAuditData());
  }

  sortBy(event, column) {
    // check to see if same column or new column was clicked
    if (this.sortKey !== column) {
      this._removeThClass('asc');
      this._removeThClass('desc');
      this.sortKey = column;
    }

    // default to ascending order
    if (!this.sortDirection || this.sortDirection === 'desc') {
      this.sortDirection = 'asc';
      event.target.classList.add('asc');
      event.target.classList.remove('desc');
    } else {
      this.sortDirection = 'desc';
      event.target.classList.add('desc');
      event.target.classList.remove('asc');
    }

    this.getEmployeeAuditData();
  }

  // #region PRIVATE METHODS

  private _removeThClass(className: string) {
    const table = document.getElementById('audit-log-table');
    const elems = table.getElementsByClassName(className);

    for (let i = 0; i < elems.length; i++) {
      elems[i].classList.remove(className);
    }
  }

  // #endregion
}
